import { render, staticRenderFns } from "./Reframing.vue?vue&type=template&id=06cb79e4&"
import script from "./Reframing.vue?vue&type=script&lang=ts&"
export * from "./Reframing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports